// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"c9e7aca0","655":"8601d2aa"}[chunkId] + ".chunk.js";
};